import { Avatar, Typography } from '@mui/material'
import { green, orange, red } from '@mui/material/colors'
import { MRT_ColumnDef } from 'material-react-table'
import React from 'react'
import { ArticuloProps } from '../../../../interfaces/articulo.ts'
import { TipoArticuloOperacionProps } from '../../../../interfaces/tipoArticulo.ts'
import { adaptColor } from '../../../../utils/colorUtils.ts'

/**
 * Columnas de la tabla de entradas
 */
export const articuloColumns: MRT_ColumnDef<ArticuloProps>[] = [
  {
    id: 'codigoArticulo',
    accessorKey: 'codigoArticulo',
    header: 'Código',
    size: 120,
    enableSorting: true,
  },
  {
    id: 'tipoArticulo',
    accessorKey: 'tipoArticulo',
    header: 'Tipo Articulo',
    size: 150,
    enableSorting: false,
    Cell: ({ cell }) => {
      return cell.getValue<TipoArticuloOperacionProps>()?.descripcion || ''
    },
  },
  {
    id: 'nombreArticulo',
    accessorKey: 'nombreArticulo',
    header: 'Nombre',
    Cell: ({ renderedCellValue, row }) => {
      return (
        <>
          {row.original.imagen ? (
            <Avatar
              src={row.original.imagen.variants.thumbnail}
              sx={{ width: 30, height: 30, mr: 2 }}
            >
              I
            </Avatar>
          ) : (
            <Avatar sx={{ width: 30, height: 30, mr: 2 }}>I</Avatar>
          )}
          {renderedCellValue}
        </>
      )
    },
    enableSorting: false,
  },
  {
    accessorKey: 'claseArticulo',
    header: 'Clase Articulo',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'gestionArticulo',
    header: 'Gestión Articulo',
    size: 120,
    enableSorting: false,
  },
  {
    id: 'verificarStock',
    accessorKey: 'verificarStock',
    header: 'verificarStock',
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? 'SI' : 'NO'
    },
    muiTableBodyCellProps: ({ row }) => ({
      sx: (theme) => ({
        backgroundColor: row.original.verificarStock
          ? adaptColor(green[200], theme)
          : adaptColor(orange[100], theme),
      }),
      align: 'center',
    }),
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
  },
  // {
  //   accessorKey: 'articuloInventario',
  //   header: 'Inv.',
  //   size: 60,
  //   Cell: ({ renderedCellValue }) => {
  //     return renderedCellValue === true ? (
  //       <Typography variant={'subtitle2'} color={'success'}>
  //         SI
  //       </Typography>
  //     ) : (
  //       <Typography variant={'subtitle2'} color={'warning'}>
  //         NO
  //       </Typography>
  //     )
  //   },
  //   enableSorting: false,
  //   enableColumnFilter: false,
  //   enableColumnActions: false,
  // },
  {
    accessorKey: 'articuloVenta',
    header: 'Venta',
    size: 65,
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? (
        <Typography variant={'subtitle2'} color={'success'}>
          SI
        </Typography>
      ) : (
        <Typography variant={'subtitle2'} color={'warning'}>
          NO
        </Typography>
      )
    },
    enableSorting: false,
    enableColumnFilter: false,
    enableColumnActions: false,
  },
  {
    accessorKey: 'articuloCompra',
    size: 65,
    header: 'Compra',
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? (
        <Typography variant={'subtitle2'} color={'success'}>
          SI
        </Typography>
      ) : (
        <Typography variant={'subtitle2'} color={'warning'}>
          NO
        </Typography>
      )
    },
    enableSorting: false,
    enableColumnFilter: false,
    enableColumnActions: false,
  },
  {
    accessorKey: 'activo',
    header: 'activo',
    size: 100,
    muiTableHeadCellProps: {
      align: 'center',
    },
    muiTableBodyCellProps: ({ row }) => ({
      sx: (theme) => ({
        backgroundColor: row.original.activo
          ? adaptColor(green[100], theme)
          : adaptColor(red[100], theme),
      }),
      align: 'center',
    }),
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? <strong>SI</strong> : <strong>NO</strong>
    },
    enableSorting: false,
    enableColumnFilter: false,
    enableColumnActions: false,
  },
]
